export default "__VITE_ASSET__Dx$3fYhA__"